/* Delivery countdown (interim). Config from the delivery_countdown metaobject
   via snippets/delivery-countdown.liquid. See docs/delivery-countdown.md */
(function () {
  'use strict';
  const KEYS = 'sun mon tue wed thu fri sat'.split(' ');
  const NAMES = 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday'.split(' ');
  const fmts = {};

  const toUTC = (ymd, h, m) => {
    const p = ymd.split('-');
    return Date.UTC(+p[0], p[1] - 1, +p[2], h || 0, m || 0);
  };
  const dayOf = (ymd) => new Date(toUTC(ymd, 0, 0)).getUTCDay();
  const addDays = (ymd, n) => new Date(toUTC(ymd, 0, 0) + n * 864e5).toISOString().slice(0, 10);

  // Wall clock in tz. The visitor's own timezone is never consulted.
  function parts(ts, tz) {
    try {
      if (!fmts[tz]) fmts[tz] = new Intl.DateTimeFormat('en-GB', { timeZone: tz,
        hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit' });
      const b = {};
      for (const p of fmts[tz].formatToParts(ts)) b[p.type] = p.value;
      return b.year && { ymd: b.year + '-' + b.month + '-' + b.day, hour: +b.hour % 24, minute: +b.minute };
    } catch (e) { return null; }
  }

  // UTC instant whose wall clock in tz is ymd at mins. Iterating on the drift
  // keeps DST transitions right without shipping a timezone database.
  function instant(ymd, mins, tz) {
    const want = toUTC(ymd, Math.floor(mins / 60), mins % 60);
    let ts = want, p, drift;
    for (let i = 0; i < 4; i++) {
      if (!(p = parts(ts, tz))) return want;
      if (!(drift = want - toUTC(p.ymd, p.hour, p.minute))) break;
      ts += drift;
    }
    return ts;
  }

  const isBusinessDay = (ymd, c) =>
    c.dispatch_days.includes(KEYS[dayOf(ymd)]) && !c.holidays.includes(ymd);
  const nextBusinessDay = (ymd, c) => {
    for (let i = 0; i < 400; i++) if (isBusinessDay((ymd = addDays(ymd, 1)), c)) return ymd;
    return null;
  };
  const advanceBusinessDays = (ymd, n, c) => {
    for (let i = 0; i < n && ymd; i++) ymd = nextBusinessDay(ymd, c);
    return ymd;
  };

  function normaliseConfig(raw) {
    const t = raw && /^(\d{1,2}):(\d{2})$/.exec(String(raw.cutoff).trim());
    const timezone = String((raw && raw.timezone) || '').trim();
    if (!t || t[1] > 23 || t[2] > 59 || !timezone || !parts(0, timezone)) return null;
    const arr = (v) => (Array.isArray(v) ? v : []);
    const int = (v) => Math.max(0, parseInt(v, 10) || 0);
    const str = (v) => (typeof v === 'string' ? v : '');
    const days = arr(raw.dispatch_days).map((d) => String(d).trim().slice(0, 3).toLowerCase())
      .filter((d, i, a) => KEYS.includes(d) && a.indexOf(d) === i);
    return days.length ? {
      cutoff_minutes: t[1] * 60 + +t[2], timezone, dispatch_days: days,
      holidays: arr(raw.holidays).map(String).filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d)),
      transit_days: int(raw.transit_days), lead_time_days: int(raw.lead_time_days),
      message_countdown: str(raw.message_countdown), message_order_now: str(raw.message_order_now)
    } : null;
  }

  const MONTHS = 'January February March April May June July August September October November December'.split(' ');
  // "Wednesday 19 August" - matches the Figma PDP.
  const longDay = (ymd) => {
    const p = ymd.split('-');
    return NAMES[dayOf(ymd)] + ' ' + +p[2] + ' ' + MONTHS[p[1] - 1];
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (ch) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

  // Fills the metaobject template. wrap(value, kind) decorates each placeholder
  // value (kind is 'time' or 'day'); plain text when omitted. Under an hour the
  // hours vanish: "Order within 12m for delivery Tuesday 15 September".
  function buildMessage(state, c, hours, minutes, day, wrap) {
    let out = state === 'countdown' ? c.message_countdown : c.message_order_now;
    if (!out) return '';
    const w = wrap || ((v) => v);
    if (wrap) out = esc(out);
    if (state === 'countdown') {
      out = (hours ? out.replace('{hours}', w(hours + 'h', 'time'))
        : out.replace(/\{hours\}\s*(and\s+)?/i, '')
      ).replace('{minutes}', w(minutes + 'm', 'time'));
    }
    return out.replace(/\{day\}/g, w(day, 'day')).replace(/\s{2,}/g, ' ').trim();
  }

  // Secondary line, derived from the same config: "Order before 4pm for next working day delivery".
  function buildSubline(c) {
    const h = Math.floor(c.cutoff_minutes / 60), m = c.cutoff_minutes % 60;
    const clock = (h % 12 || 12) + (m ? ':' + String(m).padStart(2, '0') : '') + (h < 12 ? 'am' : 'pm');
    const days = c.lead_time_days + c.transit_days;
    return 'Order before ' + clock + (days === 1
      ? ' for next working day delivery'
      : ' for delivery in ' + days + ' working days');
  }

  // now is wall clock in c.timezone: { ymd, hour, minute }.
  function computeState(now, c) {
    if (!now || !c) return null;
    const mins = now.hour * 60 + now.minute;
    const live = isBusinessDay(now.ymd, c) && mins < c.cutoff_minutes;
    const state = live ? 'countdown' : 'order-now';
    const target = live ? instant(now.ymd, c.cutoff_minutes, c.timezone) : null;
    let dispatchDay = live ? now.ymd : nextBusinessDay(now.ymd, c);
    if (c.lead_time_days) dispatchDay = advanceBusinessDays(dispatchDay, c.lead_time_days, c);
    const deliveryDay = advanceBusinessDays(dispatchDay, c.transit_days, c);
    if (!deliveryDay) return null;
    const left = live ? Math.max(0, (target - instant(now.ymd, mins, c.timezone)) / 6e4) : 0;
    const hours = Math.floor(left / 60), minutes = Math.floor(left) % 60;
    const day = longDay(deliveryDay);
    const span = (v, kind) => '<span class="delivery-countdown__' + kind + '">' + esc(v) + '</span>';
    return { state, target, dispatchDay, deliveryDay, hours, minutes,
      message: buildMessage(state, c, hours, minutes, day),
      html: buildMessage(state, c, hours, minutes, day, span),
      subline: buildSubline(c) };
  }

  globalThis.DeliveryCountdown = { computeState, normaliseConfig, isBusinessDay,
    nextBusinessDay, advanceBusinessDays, buildMessage, buildSubline };

  if (typeof document === 'undefined' || window.deliveryCountdownStarted) return;
  window.deliveryCountdownStarted = true;

  // Anything invalid leaves the reserved placeholder empty rather than guessing.
  const paint = (el) => {
    const text = el.querySelector('.delivery-countdown__text');
    const sub = el.querySelector('.delivery-countdown__subline');
    let c;
    try { c = normaliseConfig(JSON.parse(el.getAttribute('data-config'))); } catch (e) {}
    const out = c && computeState(parts(Date.now(), c.timezone), c);
    if (!text || !out || !out.message) return;
    if (text.innerHTML !== out.html) text.innerHTML = out.html;
    if (sub && sub.textContent !== out.subline) sub.textContent = out.subline;
    el.setAttribute('data-state', out.state);
  };
  const paintAll = (r) => (r && r.querySelectorAll ? r : document)
    .querySelectorAll('[data-delivery-countdown]').forEach(paint);
  const start = () => {
    paintAll();
    setInterval(() => paintAll(), 3e4);
    document.addEventListener('visibilitychange', () => document.hidden || paintAll());
    document.addEventListener('shopify:section:load', (e) => paintAll(e.target));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
